// import { useCallback, useContext, useMemo, useState, useEffect, useRef } from 'react';
// import { LuEdit } from 'react-icons/lu';
// import { MdDelete } from 'react-icons/md';
// import { IoMdAddCircle } from 'react-icons/io';
// import { Flex, Flexed, Input, MainWrap, Wrap } from '../../utilities/Shared';
// import Modal from '../../modals/Modal';
// import NewCustomer from './NewCustomer';
// import EditCustomer from './EditCustomer';
// import DeleteConfirm from '../../utilities/DeleteConfirm';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
// import 'react-tabs/style/react-tabs.css';
// import CustomerPanel from './CustomerPanel';
// import Spin from '../../components/Spinner/Spin';
// import CustomersContext from '../../Context/CustomersContext';
// import debounce from 'lodash/debounce';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// const Customers = () => {
//   const { lists, setLists, spin, error, refreshData } = useContext(CustomersContext);
//   const [searchInput, setSearchInput] = useState('');
//   const [search, setSearch] = useState('');
//   const [newVendor, setNewVendor] = useState(false);
//   const [editVendor, setEditVendor] = useState(false);
//   const [deletevendor, setDeletevendor] = useState(false);
//   const [reset, setReset] = useState(false);
//   const [vendorinfo, setVendorinfo] = useState({});
//   const [sort, setSort] = useState({ field: null, dir: 'asc' });
//   const containerRef = useRef(null);
//   const [hasLoaded, setHasLoaded] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         if (entries[0].isIntersecting && !hasLoaded) {
//           refreshData(true);
//           setHasLoaded(true);
//         }
//       },
//       { threshold: 0.1 }
//     );

//     if (containerRef.current) {
//       observer.observe(containerRef.current);
//     }

//     return () => {
//       if (containerRef.current) {
//         observer.unobserve(containerRef.current);
//       }
//     };
//   }, [refreshData, hasLoaded]);

//   useEffect(() => {
//     if (reset) {
//       refreshData(true);
//       setReset(false);
//     }
//   }, [reset, refreshData]);

//   const debouncedSetSearch = useCallback(
//     debounce((value) => {
//       setSearch(value);
//     }, 100),
//     []
//   );

//   const handleSearchChange = useCallback(
//     (e) => {
//       const value = e.target.value;
//       setSearchInput(value);
//       debouncedSetSearch(value);
//     },
//     [debouncedSetSearch]
//   );

//   const setVendorinfoCallback = useCallback((info) => {
//     setVendorinfo(info);
//   }, []);

//   const setEditVendorCallback = useCallback((value) => {
//     setEditVendor(value);
//   }, []);

//   const setDeleteVendorCallback = useCallback((value) => {
//     setDeletevendor(value);
//   }, []);

//   const DeleteVendor = async () => {
//     try {
//       await axios.delete(`https://highgroundapi.herokuapp.com/customers/delete/${vendorinfo.company_id}`);
//       toast.success('Customer deleted successfully!');
//       setReset(true);
//       setDeletevendor(false);
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Failed to delete customer.');
//     }
//   };

//   const memoizedVendorlist = useMemo(() => lists.vendors || [], [lists.vendors]);

//   const alphabet = [
//     'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
//     'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
//   ];



//   const renderTabPanel = useCallback(
//     (letter, list) => (
//       <TabPanel key={letter}>
//         <CustomerPanel
//           rowclass="mainrow_c"
//           vendorlist={list.filter(
//             (option) =>
//               option.name?.startsWith(letter) || option.name?.startsWith(letter.toLowerCase())
//           )}
//           search={search}
//           setVendorinfo={setVendorinfoCallback}
//           setEditVendor={setEditVendorCallback}
//           setDeletevendor={setDeleteVendorCallback}
//           setList={setLists}
//           setSort={setSort}
//           sort={sort}
//         />
//       </TabPanel>
//     ),
//     [search, setVendorinfoCallback, setEditVendorCallback, setDeleteVendorCallback, setLists, sort, setSort]
//   );


//   console.log(memoizedVendorlist) 
//   return (
//     <MainWrap ref={containerRef}>
//       <Wrap style={{ padding: '30px 40px 0px 40px' }}>
//         {spin && <Spin asOverlay />}
//         {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
//         <Flexed margin="20px 0px 0px 0px">
//           <Flex>
//             <Input
//               type="text"
//               value={searchInput}
//               placeholder="Search"
//               onChange={handleSearchChange}
//             />
//           </Flex>
//           <Flex flex=".3" textAlign="right">
//             <IoMdAddCircle
//               onClick={() => setNewVendor(true)}
//               style={{ fontSize: 'calc(1.7rem + .4vw)', color: 'var(--plsGreen)' }}
//             />
//           </Flex>
//         </Flexed>
//         <Modal
//           show={newVendor}
//           width="60%"
//           onCancel={() => setNewVendor(false)}
//         >
//           <NewCustomer
//             onCancel={() => setNewVendor(false)}
//             reset={reset}
//             setReset={setReset}
//           />
//         </Modal>
//         <Modal
//           show={editVendor}
//           header="Edit Customer"
//           onCancel={() => setEditVendorCallback(false)}
//         >
//           <EditCustomer
//             onCancel={() => setEditVendorCallback(false)}
//             reset={reset}
//             setReset={setReset}
//             vendorinfo={vendorinfo}
//           />
//         </Modal>
//         <Modal
//           show={deletevendor}
//           header={`Confirm you are deleting Customer -- ${vendorinfo?.name}`}
//           onCancel={() => setDeleteVendorCallback(false)}
//         >
//           <DeleteConfirm
//             editinfo={vendorinfo}
//             reset={reset}
//             setReset={setReset}
//             handleChange={DeleteVendor}
//             onCancel={() => setDeleteVendorCallback(false)}
//           />
//         </Modal>
//         <Tabs>
//           <TabList>
//             <Tab className="react-tabs__tab c">All</Tab>
//             {alphabet.map((letter) => (
//               <Tab key={letter} className="react-tabs__tab c">
//                 {letter}
//               </Tab>
//             ))}
//           </TabList>
//           <TabPanel>
//             <CustomerPanel
//               rowclass="mainrow_c"
//               vendorlist={memoizedVendorlist}
//               search={search}
//               setVendorinfo={setVendorinfoCallback}
//               setEditVendor={setEditVendorCallback}
//               setDeletevendor={setDeleteVendorCallback}
//               setList={setLists}
//               setSort={setSort}
//               sort={sort}
//             />
//           </TabPanel>
//           {alphabet.map((letter) => renderTabPanel(letter, memoizedVendorlist))}
//         </Tabs>
//       </Wrap>
//     </MainWrap>
//   );
// };

// export default Customers;




import { useCallback, useContext, useMemo, useState, useEffect, useRef } from 'react';
import { LuEdit } from 'react-icons/lu';
import { MdDelete } from 'react-icons/md';
import { IoMdAddCircle } from 'react-icons/io';
import { Flex, Flexed, Input, MainWrap, Wrap } from '../../utilities/Shared';
import Modal from '../../modals/Modal';
import NewCustomer from './NewCustomer';
import EditCustomer from './EditCustomer';
import DeleteConfirm from '../../utilities/DeleteConfirm';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import CustomerPanel from './CustomerPanel';
import Spin from '../../components/Spinner/Spin';
import CustomersContext from '../../Context/CustomersContext';
import debounce from 'lodash/debounce';
import axios from 'axios';
import { toast } from 'react-toastify';

const Customers = () => {
  const { lists, setLists, spin, error, refreshData } = useContext(CustomersContext);
  const [searchInput, setSearchInput] = useState('');
  const [search, setSearch] = useState('');
  const [newVendor, setNewVendor] = useState(false);
  const [editVendor, setEditVendor] = useState(false);
  const [deletevendor, setDeletevendor] = useState(false);
  const [reset, setReset] = useState(false);
  const [vendorinfo, setVendorinfo] = useState({});
  const [sort, setSort] = useState({ field: null, dir: 'asc' });
  const containerRef = useRef(null);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasLoaded) {
          refreshData(true);
          setHasLoaded(true);
        }
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, [refreshData, hasLoaded]);

  useEffect(() => {
    if (reset) {
      refreshData(true);
      setReset(false);
    }
  }, [reset, refreshData]);

  const debouncedSetSearch = useCallback(
    debounce((value) => {
      setSearch(value);
    }, 100),
    []
  );

  const handleSearchChange = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchInput(value);
      debouncedSetSearch(value);
    },
    [debouncedSetSearch]
  );

  const setVendorinfoCallback = useCallback((info) => {
    setVendorinfo(info);
  }, []);

  const setEditVendorCallback = useCallback((value) => {
    setEditVendor(value);
  }, []);

  const setDeleteVendorCallback = useCallback((value) => {
    setDeletevendor(value);
  }, []);

  const DeleteVendor = async () => {
    try {
      await axios.delete(`https://highgroundapi.herokuapp.com/customers/delete/${vendorinfo.company_id}`);
      toast.success('Customer deleted successfully!');
      setReset(true);
      setDeletevendor(false);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to delete customer.');
    }
  };

  const memoizedVendorlist = useMemo(() => lists.vendors || [], [lists.vendors]);

  const alphabet = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
    'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
  ];

  const renderTabPanel = useCallback(
    (letter, list) => (
      <TabPanel key={letter}>
        <CustomerPanel
          rowclass="mainrow_c"
          vendorlist={list.filter(
            (option) =>
              option.name?.startsWith(letter) || option.name?.startsWith(letter.toLowerCase())
          )}
          search={search}
          setVendorinfo={setVendorinfoCallback}
          setEditVendor={setEditVendorCallback}
          setDeletevendor={setDeleteVendorCallback}
          setList={setLists}
          setSort={setSort}
          sort={sort}
        />
      </TabPanel>
    ),
    [search, setVendorinfoCallback, setEditVendorCallback, setDeleteVendorCallback, setLists, sort]
  );

  return (
    <MainWrap ref={containerRef}>
      <Wrap style={{ padding: '30px 40px 0px 40px' }}>
        {spin && <Spin asOverlay />}
        {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
        <Flexed margin="20px 0px 0px 0px">
          <Flex>
            <Input
              type="text"
              value={searchInput}
              placeholder="Search by customer name or sales rep"
              onChange={handleSearchChange}
            />
          </Flex>
          <Flex flex=".3" textAlign="right">
            <IoMdAddCircle
              onClick={() => setNewVendor(true)}
              style={{ fontSize: 'calc(1.7rem + .4vw)', color: 'var(--plsGreen)' }}
            />
          </Flex>
        </Flexed>
        <Modal
          show={newVendor}
          width="60%"
          onCancel={() => setNewVendor(false)}
        >
          <NewCustomer
            onCancel={() => setNewVendor(false)}
            reset={reset}
            setReset={setReset}
          />
        </Modal>
        <Modal
          show={editVendor}
          header="Edit Customer"
          onCancel={() => setEditVendorCallback(false)}
        >
          <EditCustomer
            onCancel={() => setEditVendorCallback(false)}
            reset={reset}
            setReset={setReset}
            vendorinfo={vendorinfo}
          />
        </Modal>
        <Modal
          show={deletevendor}
          header={`Confirm you are deleting Customer -- ${vendorinfo?.name}`}
          onCancel={() => setDeleteVendorCallback(false)}
        >
          <DeleteConfirm
            editinfo={vendorinfo}
            reset={reset}
            setReset={setReset}
            handleChange={DeleteVendor}
            onCancel={() => setDeleteVendorCallback(false)}
          />
        </Modal>
        <Tabs>
          <TabList>
            <Tab className="react-tabs__tab c">All</Tab>
            {alphabet.map((letter) => (
              <Tab key={letter} className="react-tabs__tab c">
                {letter}
              </Tab>
            ))}
          </TabList>
          <TabPanel>
            <CustomerPanel
              rowclass="mainrow_c"
              vendorlist={memoizedVendorlist}
              search={search}
              setVendorinfo={setVendorinfoCallback}
              setEditVendor={setEditVendorCallback}
              setDeletevendor={setDeleteVendorCallback}
              setList={setLists}
              setSort={setSort}
              sort={sort}
            />
          </TabPanel>
          {alphabet.map((letter) => renderTabPanel(letter, memoizedVendorlist))}
        </Tabs>
      </Wrap>
    </MainWrap>
  );
};

export default Customers;